import { useUserConfig } from '@littlebird/sdk';
import { observer } from 'mobx-react-lite';

import { subscriptionStore } from '@/features/subscription/subscription.store';
import { uiStore } from '@/stores/ui.store';

import { useAutomaticMeetingPrepEnabled } from './automatic-meeting-prep.hooks';
import { MeetingOptInBanner } from './meeting-opt-in-banner';
import { meetingStore } from './meetings.state';

export const AutomaticMeetingPrepBanner = observer(
  function AutomaticMeetingPrepBanner() {
    const userConfig = useUserConfig();
    const automaticMeetingPrepEnabled = useAutomaticMeetingPrepEnabled();
    // Until the plan is known the setting resolves against the default
    // (basic) plan, which would flash this opt-in prompt at paid users.
    const planHydrated = subscriptionStore.state.lastUpdated !== null;
    const visible =
      planHydrated &&
      !automaticMeetingPrepEnabled &&
      !uiStore.automaticMeetingPrepBannerDismissed &&
      !meetingStore.shouldShowOnboardingChecklist;

    if (!visible) return null;

    return (
      <MeetingOptInBanner
        title="Walk into meetings prepared"
        subtitle="Littlebird can brief you before each meeting — attendees, past notes, open threads."
        turnOnAriaLabel="Turn on automatic meeting prep"
        dismissAriaLabel="Not now, automatic meeting prep"
        onTurnOn={() =>
          userConfig.meetings.set('automatic_meeting_prep_enabled', true)
        }
        onDismiss={() => uiStore.dismissAutomaticMeetingPrepBanner()}
      />
    );
  }
);
